import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { MSG_ERRORS } from '@app/utils/error-messages';


@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  constructor(
    private loggerService: LoggerService
  ) {}

/**
 * Handle errors for myta, passing callback function to handle specific errors without provide forms and stepper
 * @param err 
 * @param onPrimaryUniqueError 
 * @param onSlotNotAvailableError 
 * @param onOrderNumberError 
 * @param onGenericError 
 */
  handleGenericErrors(
    err: any, 
    onTarnsportistaError: () => void,
    onPrimaryUniqueError: () => void, 
    onSlotNotAvailableError: () => void,
    onOrderNumberError: () => void,
    onGenerateTransportError: () => void,
    onGenericError: () => void 
  ): void {
    // Delegate responsibility to function component 
    //this.loggerService.debug(`Error: ${JSON.stringify(err.error.error)}`);
	  /*
      err = ERROR_TRANSPORTISTA ( Al obtener el transporte desde SAP)
      err.error.message = message error (Al obtener datos desde el backend)
      err.error.error = complete error object    
    */  
    if(err === MSG_ERRORS.error_transportista || err.error?.text != undefined || this.wrongTransportistaFromWs(err)) { // SAP
      this.loggerService.debug(`Error: ${JSON.stringify(err)}`);
      onTarnsportistaError()
    } else if (err.error.message === MSG_ERRORS.primary_unique) { // BACKEND
      this.loggerService.debug(`Error: ${JSON.stringify(err.error.error)}`);
      onPrimaryUniqueError();
    } else if (err.error.error === MSG_ERRORS.slot_not_available) {
      // Check what error are coming here
      this.loggerService.debug(`Error: ${JSON.stringify(err.error.error)}`);
      onSlotNotAvailableError();
    } else if (err.error.error && err.error.error === MSG_ERRORS.qr_already_generated) {
      this.loggerService.debug(`Error: ${JSON.stringify(err.error.error)}`);
      onOrderNumberError();
    } else if (err.error.error && err.error.error === MSG_ERRORS.order_not_available) {
      this.loggerService.debug(`Error: ${JSON.stringify(err.error.error)}`);
      onGenerateTransportError();
    } else {
      this.loggerService.debug(`Error: ${JSON.stringify(err)}`);
      onGenericError();
    }

  }

  //TODO: en FASE 2, chequear como vienen estos datos y hacerlo generico
  
  private getMytaSpecificErrorMessage(err: any): string {
    return (
      (err.error.error && err.error.error.length > 0
        ? err.error.error === "SLOT not available"
          ? "Slot no disponible. Elija un nuevo slot"
          : err.error.error === "CIF driver data"
          ? "Ya existe una previsión para este pedido para el día de hoy"
          : err.error.error
        : err.error.code
        ? err.error.code
        : err.error.errorMessages === "PRIMARY must be unique"
        ? "Esta previsión ya ha sido generada"
        : err.error.errorMessages) +
      " " +
      err.error.message
    );
  }

  /**
   * Check if exists error in message. This case is when the error is received directly from the WS
   * @param err 
   * @returns 
   */
  private wrongTransportistaFromWs(err) {
    // Format error :
    //" Code: {\"Value\":\"env:Sender\"} Reason: {\"Text\":{\"$attributes\":{\"lang\":\"en\"},\"$value\":\"ERROR_TRANSPORTISTA\"}} Detail: {\"ZRFC_GET_SHIPPING_INFO.Exception\":{\"Name\":\"ERROR_TRANSPORTISTA\",\"Text\":\"Shipment 3060961 does not exist\",\"Message\":{\"ID\":\"VW\",\"Number\":\"010\"}}}"
    console.log(err);
    if ( err.error.message) {
      return err.error.message.includes('ERROR_TRANSPORTISTA');
    }
    return false
    
  }

}
